module.exports = __webpack_public_path__ + "img/img_sub_ser_transformation_02.d5f326fa.svg";